// Archivo migrado a MUI v5 con DataGrid y acciones modernas
import React, { Component } from 'react';
import './PerfilMobiliarioCalReal.css';
import { getCalibracionesActivo, clearErrors, deleteCalActivo, subirArchivoCalActivo } from '../../../redux/actions/mobiliarioactions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FaArrowLeft, FaCheck, FaCheckCircle, FaPlus, FaTrash } from 'react-icons/fa';
import { DataGrid } from '@mui/x-data-grid';
import {
  Dialog, DialogActions, DialogContent, DialogTitle,
  TextField, CircularProgress, IconButton, Tooltip, Stack, Grid, Typography
} from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DescriptionIcon from '@mui/icons-material/Description';
import DeleteIcon from '@mui/icons-material/Delete';
import MyButton from '../../../utils/MyButton';
import { esES } from '@mui/x-data-grid';
class PerfilMobiliarioCalReal extends Component {
  state = {
    selectedFile: null,
    progid: '',
    openatach: false,
    open: false,
    opendelete: false,
    fecha: '',
    horainicio: '',
    horafinal: '',
    numcertificado: '',
    reporteurl: '',
    reportefilename: '',
    calibracionid: '',
    errors: {},
    aprobado: {}
  };

  componentDidMount() {
    this.props.getCalibracionesActivo(this.props.mobiliarioId);
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    if (props.UI.errors) newState.errors = props.UI.errors;
    if (props.UI.aprobado) newState.aprobado = props.UI.aprobado;
    return Object.keys(newState).length > 0 ? newState : null;
  }

  handleOpenAtach = (calibracionid) => {
    this.setState({ openatach: true, calibracionid ,aprobado: {}, errors: {} });
  };

  handleCloseAtach = () => {
       const resetState = { openatach: false,aprobado: {}, errors: {},selectedFile: null };
        if (this.state.aprobado.mensaje) this.props.getCalibracionesActivo(this.props.mobiliarioId);
        this.setState(resetState);
    
  };

  onFileChange = event => {
    this.setState({ selectedFile: event.target.files[0] });
  };

  onFileUpload = () => {
    console.log('CalibracionId'+this.state.calibracionid)
    const formData = new FormData();
    formData.append("myFile", this.state.selectedFile, this.state.selectedFile.name);
    this.props.subirArchivoCalActivo(formData, this.state.calibracionid); // ✅ CORRECTO
  };

  handleOpen = (data) => {
    this.setState({
      open: true,
      fecha: data.fecha || '',
      horainicio: data.horainicio || '',
      horafinal: data.horafinal || '',
      numcertificado: data.numcertificado || '',
      reporteurl: data.reporteurl || ''
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleOpenDelete = (data) => {
    this.setState({ opendelete: true, reportefilename: data.reportefilename, calibracionid: data.calibracionid,aprobado: {}, errors: {}  });
  };

  handleCloseDelete = () => {
    const resetState = { opendelete: false,aprobado: {}, errors: {},selectedFile: null };
    if (this.state.aprobado.mensaje) this.props.getCalibracionesActivo(this.props.mobiliarioId);
    this.setState(resetState);
  };

  handleDelete = () => {
  
    this.props.deleteCalActivo(this.state.calibracionid);
   
  };

  render() {
    const { calibracionesmob, loadingcal } = this.props.dataMob;
    const rows = calibracionesmob || [];
    const { errors, aprobado} = this.state;
    const { UI: { loading } } = this.props;

    const columns = [
        {
            field: 'acciones',
            headerName: 'Acciones',
            flex:1, minwidth:120,
            sortable: false,
            renderCell: (params) => (
              <Stack direction="row" spacing={1}>
                <Tooltip title="Ver Reporte">
                  <IconButton color="primary" onClick={() => this.handleOpen(params.row)}>
                    <AssignmentIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Adjuntar Certificado">
                  <IconButton color="primary" onClick={() => this.handleOpenAtach(params.row.calibracionid)}>
                    <AttachFileIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Borrar Calibración">
                  <IconButton color="#d7d7d7" onClick={() => this.handleOpenDelete(params.row)}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </Stack>
            )
          },
      { field: 'fecha', headerName: 'Fecha', flex:1, minwidth:120},
      { field: 'numcertificado', headerName: 'No. Certificado', flex:1, minwidth:120},
      {
        field: 'reporteurl',
        headerName: 'Link Certificado',
        flex:1, minwidth:120,
        renderCell: (params) =>
          params.value === 'false' ? (
            <Typography variant="body2">Sin Certificado Adjunto</Typography>
          ) : (
            <Tooltip title="Ver Certificado">
              <IconButton
                component="a"
                href={params.value}
                target="_blank"
                rel="noopener noreferrer"
                size="small"
              >
                <DescriptionIcon color="primary" />
              </IconButton>
            </Tooltip>
          ),
      },
      
    ];

    return (
      <div className="listamtoprog-container">
        <div className="listamtoprog-table">
          {loadingcal ? (
            <div className="div_cargando">
              <CircularProgress size={50} color="primary" />
            </div>
          ) : (
            <DataGrid
              rows={rows}
              columns={columns}
              getRowId={(row) => row.calibracionid}
              autoHeight
              pageSize={5}
              rowsPerPageOptions={[5, 10, 20]}
              localeText={esES.components.MuiDataGrid.defaultProps.localeText} // 👈 Esto cambia TODO a Español
              sx={{
                borderRadius: 2,
                backgroundColor: '#fff',
                boxShadow: 3,
                '& .MuiDataGrid-cell': {
                  fontSize: 14,
                },
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#0588FB',
                  color: '#fff',
                  fontWeight: 'bold',
                  fontSize: 15,
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}
               disableSelectionOnClick
            />
          )}
        </div>

        <Dialog open={this.state.open} onClose={this.handleClose} fullWidth maxWidth="sm">
          <DialogTitle>Reporte de Calibración</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={12}>
                <TextField fullWidth type="date" label="Fecha de Realización" value={this.state.fecha}
                  InputLabelProps={{ shrink: true }} InputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={6}>
                <TextField fullWidth type="time" label="Hora de Inicio" value={this.state.horainicio}
                  InputLabelProps={{ shrink: true }} InputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={6}>
                <TextField fullWidth type="time" label="Hora Final" value={this.state.horafinal}
                  InputLabelProps={{ shrink: true }} InputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth label="Número del Certificado" value={this.state.numcertificado}
                  InputLabelProps={{ shrink: true }} InputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={12}>
                {this.state.reporteurl === 'false' ? (
                    <Typography>Sin Certificado Adjunto</Typography>
                ) : (
                    <Tooltip title="Ver Certificado">
                    <IconButton
                        component="a"
                        href={this.state.reporteurl}
                        target="_blank"
                        rel="noopener noreferrer"
                        size="small"
                    >
                        <AssignmentIcon color="primary" />
                    </IconButton>
                    </Tooltip>
                )}
                </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}>
              <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
            </MyButton>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.openatach} onClose={this.handleCloseAtach} fullWidth maxWidth="sm">
          {aprobado.mensaje ? (
                      <div className='div-aprobado'>
                        <div className='div-icono-aprobado'>
                          <FaCheck color="#ffffff" className='icono-aprobado' />
                        </div>
                        <h2 className='text-aprobado'>Reporte Cargado Exitosamente</h2>
                      </div>
                    ) : (
                      <>
                        <DialogTitle>Subir Certificado de Calibración</DialogTitle>
                        <DialogContent>
                    {/* Dropzone interactivo */}
                    <div
                        onClick={() => this.fileInputRef.click()}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => {
                        e.preventDefault();
                        const file = e.dataTransfer.files[0];
                        if (file && file.type === 'application/pdf') {
                            this.setState({ selectedFile: file });
                        }
                        }}
                        style={{
                        border: '2px dashed #aaa',
                        borderRadius: '10px',
                        padding: '30px',
                        textAlign: 'center',
                        cursor: 'pointer',
                        backgroundColor: '#f9f9f9',
                        }}
                    >
                        {this.state.selectedFile ? (
                        <Typography variant="body2">Archivo seleccionado: {this.state.selectedFile.name}</Typography>
                        ) : (
                        <Typography variant="body2">Haz clic o arrastra un archivo PDF aquí</Typography>
                        )}
                    </div>

                    {/* Input oculto */}
                    <input
                        type="file"
                        accept=".pdf"
                        ref={(ref) => (this.fileInputRef = ref)}
                        style={{ display: 'none' }}
                        onChange={this.onFileChange}
                    />

                    </DialogContent>
                      
                      </>)}
          
        
        
                <DialogActions>
                <MyButton tip="Cerrar" onClick={this.handleCloseAtach}>
                    <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
                </MyButton>
                {loading ? (
                              <CircularProgress size={30} color="primary" className="login-progress" />
                            ) : aprobado.mensaje ? (
                              <MyButton tip="Continuar" onClick={this.handleCloseAtach}><FaCheckCircle color="#20B90C" className="icon-formulario" /></MyButton>
                            ) : (
                                <MyButton
                                tip="Subir Certificado"
                                onClick={this.onFileUpload}
                                disabled={!this.state.selectedFile}
                            >
                                <FaPlus color="#03178C" className="icon-formulario" />
                            </MyButton>
                          )}
                
                </DialogActions>
        </Dialog>

        <Dialog open={this.state.opendelete} onClose={this.handleCloseDelete} fullWidth maxWidth="sm">
          {aprobado.mensaje ? (
                     <div className='div-aprobado'>
                       <div className='div-icono-delete'>
                         <FaTrash color="#ffffff" className='icono-aprobado' />
                       </div>
                       <h2 className='text-aprobado'>Calibración Borrada Exitosamente</h2>
                     </div>
                   ) : (
                     <DialogTitle>¿Estás seguro de borrar esta Calibración? Se borrará el documento y su programación asociada</DialogTitle>
                   )}
                    <DialogActions>
                      <MyButton tip="Cerrar" onClick={this.handleCloseDelete}><FaArrowLeft color="#D3D7DC" className="icon-formulario" /></MyButton>
                      {loading ? (
                        <CircularProgress size={30} color="primary" className="login-progress" />
                      ) : aprobado.mensaje ? (
                        <MyButton tip="Continuar" onClick={this.handleCloseDelete}><FaCheckCircle color="#f9044e" className="icon-formulario" /></MyButton>
                      ) : (
                        <MyButton tip="Borrar Calibración" onClick={this.handleDelete}><FaTrash color="#03178C" className="icon-formulario" /></MyButton>
                      )}
                    </DialogActions>
        </Dialog>
      </div>
    );
  }
}

PerfilMobiliarioCalReal.propTypes = {
  getCalibracionesActivo: PropTypes.func.isRequired,
  subirArchivoCalActivo: PropTypes.func.isRequired,
  deleteCalActivo: PropTypes.func.isRequired,
  dataMob: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
  mobiliarioId: PropTypes.string,
  clienteId: PropTypes.string
};

const mapStateToProps = (state) => ({
  dataMob: state.dataMob,
  UI: state.UI
});

const mapActionsToProps = {
  getCalibracionesActivo,
  clearErrors,
  deleteCalActivo,
  subirArchivoCalActivo
};

export default connect(mapStateToProps, mapActionsToProps)(PerfilMobiliarioCalReal);